import React, { useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

const ContactInput = () => {
    const [form, setForm] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        address: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
    });
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [captchaVerified, setCaptchaVerified] = useState(false);

    const formRef = useRef<HTMLFormElement>(null);
    const iframeRef = useRef<HTMLIFrameElement>(null);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const allFieldsFilled = Object.values(form).every(val => val.trim() !== '');

    const handleCaptchaChange = (token: string | null) => {
        if (token) setCaptchaVerified(true);
    };

    const handleClick = () => {
        if (!captchaVerified || !formRef.current) return;
        setLoading(true);

        const hiddenForm = formRef.current;

        hiddenForm.querySelector<HTMLInputElement>('input[name="FNAME"]')!.value = form.firstName;
        hiddenForm.querySelector<HTMLInputElement>('input[name="LNAME"]')!.value = form.lastName;
        hiddenForm.querySelector<HTMLInputElement>('input[name="EMAIL"]')!.value = form.email;
        hiddenForm.querySelector<HTMLInputElement>('input[name="PHONE"]')!.value = form.phone;

        hiddenForm.querySelector<HTMLInputElement>('input[name="ADDRESS[addr1]"]')!.value = form.address;
        hiddenForm.querySelector<HTMLInputElement>('input[name="ADDRESS[addr2]"]')!.value = form.address2;
        hiddenForm.querySelector<HTMLInputElement>('input[name="ADDRESS[city]"]')!.value = form.city;
        hiddenForm.querySelector<HTMLInputElement>('input[name="ADDRESS[state]"]')!.value = form.state;
        hiddenForm.querySelector<HTMLInputElement>('input[name="ADDRESS[zip]"]')!.value = form.zip;
        hiddenForm.querySelector<HTMLInputElement>('input[name="ADDRESS[country]"]')!.value = form.country;

        hiddenForm.submit();

        setForm({
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            address: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            country: '',
        });
        setCaptchaVerified(false);
    };

    const handleIframeLoad = () => {
        if (loading) {
            setLoading(false);
            setShowModal(true);
        }
    };

    return (
        <>
            {/* Hidden Mailchimp Form */}
            <form
                ref={formRef}
                action="https://sporthub.us20.list-manage.com/subscribe/post?u=2f9452690b89647ce0bca7883&id=efdfdc211b&f_id=0044d0e5f0"
                method="POST"
                target="hidden_iframe"
                style={{ display: 'none' }}
            >
                <input type="text" name="FNAME" />
                <input type="text" name="LNAME" />
                <input type="email" name="EMAIL" />
                <input type="text" name="PHONE" />
                <input type="text" name="ADDRESS[addr1]" />
                <input type="text" name="ADDRESS[addr2]" />
                <input type="text" name="ADDRESS[city]" />
                <input type="text" name="ADDRESS[state]" />
                <input type="text" name="ADDRESS[zip]" />
                <input type="text" name="ADDRESS[country]" />
            </form>

            {/* Visible Inputs */}
            <div className="flex flex-col items-stretch gap-3 mb-3">
                {/* Name Fields */}
                <div className="flex flex-col lg:flex-row gap-3">
                    <input
                        type="text"
                        name="firstName"
                        value={form.firstName}
                        onChange={handleInputChange}
                        placeholder="First Name"
                        className="w-full px-4 py-3 rounded-md border border-gray-600 bg-black/20 text-white placeholder-gray-400 outline-none"
                    />
                    <input
                        type="text"
                        name="lastName"
                        value={form.lastName}
                        onChange={handleInputChange}
                        placeholder="Last Name"
                        className="w-full px-4 py-3 rounded-md border border-gray-600 bg-black/20 text-white placeholder-gray-400 outline-none"
                    />
                </div>

                {/* Contact Fields */}
                <div className="flex flex-col lg:flex-row gap-3">
                    <input
                        type="email"
                        name="email"
                        value={form.email}
                        onChange={handleInputChange}
                        placeholder="Email"
                        className="w-full px-4 py-3 rounded-md border border-gray-600 bg-black/20 text-white placeholder-gray-400 outline-none"
                    />
                    <input
                        type="text"
                        name="phone"
                        value={form.phone}
                        onChange={handleInputChange}
                        placeholder="Phone"
                        className="w-full px-4 py-3 rounded-md border border-gray-600 bg-black/20 text-white placeholder-gray-400 outline-none"
                    />
                </div>

                {/* Address Fields */}
                <input
                    type="text"
                    name="address"
                    value={form.address}
                    onChange={handleInputChange}
                    placeholder="Address Line 1"
                    className="w-full px-4 py-3 rounded-md border border-gray-600 bg-black/20 text-white placeholder-gray-400 outline-none"
                />
                <input
                    type="text"
                    name="address2"
                    value={form.address2}
                    onChange={handleInputChange}
                    placeholder="Address Line 2"
                    className="w-full px-4 py-3 rounded-md border border-gray-600 bg-black/20 text-white placeholder-gray-400 outline-none"
                />
                <div className="flex flex-col lg:flex-row gap-3">
                    <input
                        type="text"
                        name="city"
                        value={form.city}
                        onChange={handleInputChange}
                        placeholder="City"
                        className="w-full px-4 py-3 rounded-md border border-gray-600 bg-black/20 text-white placeholder-gray-400 outline-none"
                    />
                    <input
                        type="text"
                        name="state"
                        value={form.state}
                        onChange={handleInputChange}
                        placeholder="State"
                        className="w-full px-4 py-3 rounded-md border border-gray-600 bg-black/20 text-white placeholder-gray-400 outline-none"
                    />
                </div>
                <div className="flex flex-col lg:flex-row gap-3">
                    <input
                        type="text"
                        name="zip"
                        value={form.zip}
                        onChange={handleInputChange}
                        placeholder="ZIP / Postal Code"
                        className="w-full px-4 py-3 rounded-md border border-gray-600 bg-black/20 text-white placeholder-gray-400 outline-none"
                    />
                    <input
                        type="text"
                        name="country"
                        value={form.country}
                        onChange={handleInputChange}
                        placeholder="Country"
                        className="w-full px-4 py-3 rounded-md border border-gray-600 bg-black/20 text-white placeholder-gray-400 outline-none"
                    />
                </div>

                {/* CAPTCHA */}
                {allFieldsFilled && (
                    <div className="mt-4">
                        <ReCAPTCHA
                            sitekey="6LfEIVwrAAAAAEP-obnmYr9T5bPBqOGsIElW8HTQ"
                            onChange={handleCaptchaChange}
                        />
                    </div>
                )}

                {/* Submit Button */}
                <button
                    onClick={handleClick}
                    disabled={loading || !captchaVerified}
                    className={`mt-4 px-5 py-3 rounded-md transition bg-red-600 hover:bg-red-700 text-white`}
                >
                    {loading ? 'Submitting...' : 'Join the Waitlist'}
                </button>
            </div>

            {/* Hidden iframe */}
            <iframe
                name="hidden_iframe"
                ref={iframeRef}
                onLoad={handleIframeLoad}
                style={{ display: 'none' }}
                title="hidden_iframe"
            ></iframe>

            {/* Success Modal */}
            {showModal && (
                <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg max-w-sm w-full text-center shadow-lg">
                        <h2 className="text-xl font-bold text-green-600 mb-3">Success!</h2>
                        <p className="text-gray-700">You've joined the waitlist successfully.</p>
                        <button
                            onClick={() => setShowModal(false)}
                            className="mt-4 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded"
                        >
                            Close
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default ContactInput;
